/* theme-sync-rev: 2026-10-01-pdp-reviews-v3 — bump on every change to this file.
   See the matching note at the top of section-kkumi-product-reviews-photowall.js
   (the per-file content-hash sync can leave one file stale). */
/* =========================================================
 * REVIEW SUBMISSION MODAL — the "Write a review" form on the PDP reviews
 * section (sections/kkumi-product-reviews-photowall.liquid, API mode).
 * Posts to the Cloudflare reviews worker, which forwards to Judge.me's
 * /api/v1/reviews endpoint (honours the section's submit_dry_run).
 *
 * Moved verbatim out of section-kkumi-product-reviews-photowall.js so that
 * file only owns the review list. The section script calls
 * window.KKPrvModal.wire(root, helpers) once its content is rendered;
 * `helpers` supplies the section's dbg / copy / withN so this file keeps
 * using exactly the same debug log and settings-driven copy.
 * ========================================================= */
(function () {
  'use strict';
  if (window.KKPrvModal) return;

  function wire(root, helpers) {
    var dbg = helpers.dbg;
    var copy = helpers.copy;
    var withN = helpers.withN;
    return wireModal(root);

    function wireModal(root) {
        var rv = root.querySelector('.kkprv-rv');
        if (!rv) { dbg('modal — root not present'); return; }
        var openBtn = root.querySelector('[data-kkprv-open-modal]');
        var form = rv.querySelector('[data-rv-form]');
        var starsEl = rv.querySelector('[data-rv-stars]');
        var wordEl = rv.querySelector('[data-rv-rating-word]');
        var ratingWrap = rv.querySelector('[data-rv-rating]');
        var bodyEl = rv.querySelector('[data-rv-body]');
        var bodyCount = rv.querySelector('[data-rv-body-count]');
        var titleEl = rv.querySelector('[data-rv-title]');
        var nameEl = rv.querySelector('[data-rv-name]');
        var emailEl = rv.querySelector('[data-rv-email]');
        var drop = rv.querySelector('[data-rv-drop]');
        var fileIn = rv.querySelector('[data-rv-file]');
        var preview = rv.querySelector('[data-rv-preview]');
        var thumb = rv.querySelector('[data-rv-preview-thumb]');
        var previewName = rv.querySelector('[data-rv-preview-name]');
        var previewSize = rv.querySelector('[data-rv-preview-size]');
        var removeBtn = rv.querySelector('[data-rv-preview-remove]');
        var validationError = rv.querySelector('[data-rv-error]');
        var validationText = rv.querySelector('[data-rv-error-text]');
        var submitBtn = rv.querySelector('[data-rv-submit]');
        var retryBtn = rv.querySelector('[data-rv-retry]');
        var errorStateText = rv.querySelector('[data-rv-error-state-text]');
  
        var rating = 0;
        var mediaFile = null;
        var lastFocus = null;
        var defaultRatingWords = ['', 'not for me', 'just okay', 'pretty good', 'really good', 'love it!'];
        var RATING_WORDS = defaultRatingWords;
        try {
          var parsedWords = JSON.parse(root.dataset.ratingWords || 'null');
          if (Array.isArray(parsedWords) && parsedWords.length === 6) RATING_WORDS = parsedWords;
        } catch (e) { /* keep defaults */ }
        var HEART_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  
        /* ---- Star rating (hearts) ---- */
        for (var i = 1; i <= 5; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rv-star';
          b.dataset.val = i;
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-label', withN(copy(i > 1 ? 'ariaHeartOther' : 'ariaHeartOne', '{n} heart' + (i > 1 ? 's' : '')), i));
          b.innerHTML = HEART_SVG;
          starsEl.appendChild(b);
        }
        var starBtns = Array.prototype.slice.call(starsEl.querySelectorAll('.rv-star'));
        function paintStars(n) { starBtns.forEach(function (btn, i) { btn.classList.toggle('is-on', i < n); }); }
        function setRating(n) {
          rating = n;
          paintStars(n);
          wordEl.textContent = RATING_WORDS[n] || (wordEl.dataset.placeholder || 'tap a heart');
          wordEl.classList.toggle('is-empty', n === 0);
          starBtns.forEach(function (btn) { btn.setAttribute('aria-checked', String(+btn.dataset.val === n)); });
          ratingWrap.classList.remove('is-error');
          var chosen = starBtns[n - 1];
          if (chosen) { chosen.classList.remove('bounce'); void chosen.offsetWidth; chosen.classList.add('bounce'); }
        }
        if (wordEl) wordEl.dataset.placeholder = wordEl.textContent;
        starBtns.forEach(function (btn) {
          var v = +btn.dataset.val;
          btn.addEventListener('mouseenter', function () { paintStars(v); });
          btn.addEventListener('click', function () { setRating(v); });
          btn.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); setRating(Math.min(5, rating + 1)); starBtns[rating - 1].focus(); }
            if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); setRating(Math.max(1, rating - 1)); starBtns[rating - 1].focus(); }
          });
        });
        starsEl.addEventListener('mouseleave', function () { paintStars(rating); });
  
        /* ---- Media upload (one photo) ----
           Judge.me takes review photos as links, so the reviews worker stores
           the photo and passes its URL on; video can't go that way. Checked
           here too because drag-and-drop skips the input's accept filter. */
        var MAX_PHOTO_BYTES = 20 * 1024 * 1024;
        function fmtSize(bytes) {
          if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + ' KB';
          return (bytes / 1024 / 1024).toFixed(1) + ' MB';
        }
        function showMedia(file) {
          if (file.type.indexOf('image/') !== 0 || file.size > MAX_PHOTO_BYTES) {
            clearMedia();
            showValidation(root.dataset.errPhoto || 'Please choose a photo under 20 MB (jpg, png or heic).');
            return;
          }
          validationError.classList.remove('is-shown');
          mediaFile = file;
          var isVideo = file.type.indexOf('video') === 0;
          var url = URL.createObjectURL(file);
          thumb.innerHTML = isVideo
            ? '<video muted playsinline src="' + url + '"></video><span class="rv-media-preview__badge">video</span>'
            : '<img alt="" src="' + url + '"><span class="rv-media-preview__badge">photo</span>';
          previewName.textContent = file.name;
          previewSize.textContent = fmtSize(file.size);
          drop.style.display = 'none';
          preview.classList.add('is-shown');
          dbg('modal — media selected', { name: file.name, size: file.size, type: file.type });
        }
        function clearMedia() {
          mediaFile = null;
          if (fileIn) fileIn.value = '';
          preview.classList.remove('is-shown');
          thumb.innerHTML = '';
          drop.style.display = '';
        }
        if (fileIn) fileIn.addEventListener('change', function () { if (fileIn.files[0]) showMedia(fileIn.files[0]); });
        if (removeBtn) removeBtn.addEventListener('click', clearMedia);
        ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); }); });
        ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); }); });
        drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (f) showMedia(f); });
  
        /* ---- Char counter ---- */
        if (bodyEl && bodyCount) {
          bodyEl.addEventListener('input', function () { bodyCount.textContent = bodyEl.value.length + ' / 1200'; });
        }
  
        /* ---- Open / close / state views ---- */
        function setView(v) {
          rv.setAttribute('data-rv-view', v);
          if (v === 'success' || v === 'error') {
            var burst = rv.querySelector('.rv__state--' + v + ' .rv-burst');
            if (burst) {
              burst.style.animation = 'none';
              requestAnimationFrame(function () {
                void burst.offsetWidth;
                burst.style.animation = 'kkprv-rv-burst-in .5s cubic-bezier(.2,.9,.3,1.4)';
              });
            }
          }
        }
        function open() {
          setView('form');
          lastFocus = document.activeElement;
          rv.hidden = false;
          document.body.style.overflow = 'hidden';
          requestAnimationFrame(function () { rv.classList.add('is-open'); });
          setTimeout(function () {
            var closer = rv.querySelector('.rv__close');
            if (closer) closer.focus();
          }, 60);
          dbg('modal open');
        }
        function close() {
          rv.classList.remove('is-open');
          document.body.style.overflow = '';
          setTimeout(function () { rv.hidden = true; }, 280);
          if (lastFocus && lastFocus.focus) lastFocus.focus();
          dbg('modal close');
        }
        function resetForm() {
          if (form) form.reset();
          setRating(0);
          clearMedia();
          if (bodyCount) bodyCount.textContent = '0 / 1200';
          validationError.classList.remove('is-shown');
          rv.classList.remove('is-submitting');
        }
  
        if (openBtn) openBtn.addEventListener('click', open);
        // "#write-review" (the account hub's Review buttons link here):
        // bring the reviews into view and open the form straight away. With
        // no in-page form (demo mode) it just scrolls to the reviews.
        function fromHash() {
          if (window.location.hash !== '#write-review') return;
          try { root.scrollIntoView({ block: 'start' }); } catch (e) { /* noop */ }
          if (openBtn && rv.hidden) open();
        }
        fromHash();
        window.addEventListener('hashchange', fromHash);
        rv.querySelectorAll('[data-rv-close]').forEach(function (el) {
          el.addEventListener('click', function () { close(); setTimeout(resetForm, 300); });
        });
        /* Click-outside fallback: closing also fires when the click lands on
           the modal container itself (the padding area around the dialog),
           not just .rv__scrim. Covers cases where the scrim element gets
           covered or sized to zero by a parent style. */
        rv.addEventListener('click', function (e) {
          if (e.target === rv) { close(); setTimeout(resetForm, 300); }
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !rv.hidden) { close(); setTimeout(resetForm, 300); }
        });
        if (retryBtn) retryBtn.addEventListener('click', function () { setView('form'); });
  
        /* ---- Validate ---- */
        function showValidation(msg) {
          validationText.textContent = msg;
          validationError.classList.add('is-shown');
        }
        function validate(payload) {
          validationError.classList.remove('is-shown');
          if (rating === 0) {
            ratingWrap.classList.add('is-error');
            showValidation(root.dataset.errRating || 'Please add a rating before submitting.');
            return false;
          }
          if (!payload.name) { showValidation(root.dataset.errName || 'Please add your name.'); nameEl.focus(); return false; }
          if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(payload.email)) { showValidation(root.dataset.errEmail || 'Please enter a valid email address.'); emailEl.focus(); return false; }
          return true;
        }
  
        /* ---- Submit ---- */
        if (!form) return;
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var proxyUrl = root.dataset.proxyUrl;
          var productId = parseInt(root.dataset.productId, 10);
          var payload = {
            product_id: productId,
            name: (nameEl.value || '').trim(),
            email: (emailEl.value || '').trim(),
            rating: rating,
            title: (titleEl.value || '').trim(),
            body: (bodyEl.value || '').trim(),
            picture_urls: [],
          };
          dbg('modal submit — payload', payload);
  
          if (!validate(payload)) return;
          if (!proxyUrl || !productId) {
            showValidation(copy('submitErrConfig', 'Configuration error. Contact support.'));
            dbg('modal submit ABORT — missing proxy/product');
            return;
          }
          var dryRun = root.dataset.submitDryRun === '1';
          var postUrl = proxyUrl + (dryRun ? (proxyUrl.indexOf('?') >= 0 ? '&' : '?') + 'dry_run=1' : '');
          if (dryRun) dbg('modal submit — DRY-RUN (worker will not forward to Judge.me)');
  
          rv.classList.add('is-submitting');
          submitBtn.disabled = true;
  
          // With media, send multipart so the worker can forward the file to
          // Judge.me's `pictures[]` field. Without media, send JSON — slightly
          // cheaper to parse.
          var fetchOptions;
          if (mediaFile) {
            dbg('modal submit — media attached, sending multipart', { name: mediaFile.name, size: mediaFile.size, type: mediaFile.type });
            var fd = new FormData();
            fd.append('product_id', String(payload.product_id));
            fd.append('email',      payload.email);
            fd.append('name',       payload.name);
            fd.append('rating',     String(payload.rating));
            fd.append('body',       payload.body);
            if (payload.title) fd.append('title', payload.title);
            fd.append('media', mediaFile, mediaFile.name);
            fetchOptions = { method: 'POST', body: fd /* fetch derives the multipart boundary */ };
          } else {
            fetchOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload),
            };
          }
  
          // Read the reply as text first: an error page that isn't JSON must
          // surface as "Could not submit: HTTP 5xx", not as a network error.
          fetch(postUrl, fetchOptions)
            .then(function (r) {
              return r.text().then(function (t) {
                var b = null;
                try { b = t ? JSON.parse(t) : null; } catch (e) { b = null; }
                return { ok: r.ok, status: r.status, body: b };
              });
            })
            .then(function (res) {
              dbg('modal submit — response', res);
              rv.classList.remove('is-submitting');
              submitBtn.disabled = false;
              if (!res.ok) {
                var err = (res.body && (res.body.error || res.body.message)) || ('HTTP ' + res.status);
                if (errorStateText) errorStateText.textContent = copy('submitErrTpl', 'Could not submit: {err}').split('{err}').join(err);
                setView('error');
                return;
              }
              setView('success');
              resetForm();
            })
            .catch(function (err) {
              dbg('modal submit — FAILED', { error: String(err) });
              rv.classList.remove('is-submitting');
              submitBtn.disabled = false;
              if (errorStateText) errorStateText.textContent = copy('submitErrNetwork', 'Network error. Please try again.');
              setView('error');
            });
        });
  
        setRating(0);
      }
  }

  window.KKPrvModal = { wire: wire };
})();
